module.exports = __webpack_public_path__ + "static/media/flexibility@2x.8670fb43.png";